export default (state = false, action = {}) => {
  switch (action.type) {
    case 'GLOBAL_LOADING':
      return action.payload;
    default:
      return state;
  }
};
